import { provide, inject, ref, InjectionKey, Ref } from 'vue' // Importing from 'vue' in Vue 3
import appEnv from '@/support/env' // Assuming you have a file to handle environment variables

// Define the type for the application config
interface AppConfig {
  app: string
  domain: string
  termsLink: string
}

// Define the InjectionKey for the application config
const AppConfigKey: InjectionKey<Ref<AppConfig>> = Symbol('Application config')

// Provide the config object
const provideConfig = (app: string) => {
  const landingHost = appEnv.DOMAIN.replace(/app\./, '') // Assuming appEnv handles env variables
  const config: AppConfig = {
    app: app,
    domain: landingHost,
    termsLink: `${landingHost}/terms-and-conditions`
  }

  // Provide the config using the InjectionKey
  provide(AppConfigKey, ref(config))
}

// Use the provided config in components
const useConfig = (): AppConfig => {
  const config = inject(AppConfigKey)

  if (!config) throw new Error('No config provided!!!')

  return config.value
}

export { provideConfig, useConfig }
